import type { Collection } from 'state/utils/types';

export type BdrMonthlyExpiryDatesState = Collection<string[]>;

export const initialBdrMonthlyExpiryDatesState = {};
